// Module
var code = `<div class="application-panel-container-table instrument-holidays-table" style="height: {{tableHeight}}px;">
    <terceraPanel name='windowPanelBodyQT' />
</div>`;
// Exports
export default code;